import { useContext } from 'react';
import { useStore as useZustandStore } from 'zustand';
import { StoreContext } from './StoreProvider.tsx';
import { type Store } from './types.ts';

// Casting for ease of typing
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const useStore = <T = Store>(selector: (store: Store) => T = state => state as T): T => {
  const storeContext = useContext(StoreContext);

  if (!storeContext) {
    throw new Error(`useStore must be used within StoreProvider`);
  }

  return useZustandStore(storeContext, selector);
};
